<app-factor-table
  [title]="'Total Fuel Losses'"
  [factors]="factorsData"
  [formatters]="formatters"
  [modalFilterHeaders]="modalFilterHeaders">
</app-factor-table>
